import { For } from "solid-js";
import type { Component } from "solid-js";

const sectionMeta = {
  title: "Operations overview",
  description: "Monitor bookings, revenue, and robot readiness at a glance.",
  highlights: [
    "Surface live KPIs (today vs. targets).",
    "Embed quick links to payment reconciliation and upcoming cleanings.",
    "Show robot readiness and location coverage heatmaps.",
  ],
};

export const DashboardView: Component = () => {
  return (
    <section class="main-scroll-area">
      <h1 class="main-placeholder-title">{sectionMeta.title}</h1>
      <p>{sectionMeta.description}</p>
      <div class="placeholder-grid">
        <For each={sectionMeta.highlights}>{(item) => <div class="placeholder-card">{item}</div>}</For>
      </div>
    </section>
  );
};
